var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackImportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_416_715",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_416_715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 46.6668V27.6502L19.6 33.7168L16.3334 30.3335L28 18.6668L39.6667 30.3335L36.4 33.7168L30.3334 27.6502V46.6668H25.6667ZM9.33337 21.0002V14.0002C9.33337 12.7168 9.79032 11.6182 10.7042 10.7043C11.6181 9.79044 12.7167 9.3335 14 9.3335H42C43.2834 9.3335 44.382 9.79044 45.2959 10.7043C46.2098 11.6182 46.6667 12.7168 46.6667 14.0002V21.0002H42V14.0002H14V21.0002H9.33337Z",
    fill: "#1F2A37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackImportIcon);
export default __webpack_public_path__ + "static/media/blackImportIcon.3ce3a4c6f3d17541d7ec0cc97fb9d1be.svg";
export { ForwardRef as ReactComponent };